import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const MessageDeliveredGraphic = () => {
  const data = useStaticQuery(graphql`
    query {
      messageDeliveredGraphicImage: file(relativePath: { eq: "graphics/message-delivered-graphic.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Img
      fluid={data.messageDeliveredGraphicImage.childImageSharp.fluid}
      alt="Message Delivered Graphic"
    />
  )
}

export default MessageDeliveredGraphic
